import _ from "lodash";

import { useEffect } from "react";
import { useParams } from "react-router-dom";

import { NewAnomalyItem } from "../utils/models";

import anomalyService from "../services/anomalyService";
import usePreviousList from "./usePreviousList";

const useAnomalyRecords = (anomalyRecords: NewAnomalyItem[]) => {
    const params = useParams<{ projectId: string; }>();
    const previousList = usePreviousList(anomalyRecords);

    useEffect(() => {
        async function storeAnomalies() {
            if (_.isEqual(previousList, anomalyRecords)) return;

            try {
                await anomalyService.saveAnomalyRecord(params.projectId!, anomalyRecords);
            } catch (error) {
                console.log(error);
            }
        }

        storeAnomalies();

		// eslint-disable-next-line
    }, [params.projectId, previousList, anomalyRecords]);
    
    return null;
};
 
export default useAnomalyRecords;